export const config = {
    CURRENT_TERMS_VERSION: '1.0'
};
